/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Page_TitleInputs */

const en_story_bank_page_title = /** @type {(inputs: Story_Bank_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview Story Bank`)
};

const de_story_bank_page_title = /** @type {(inputs: Story_Bank_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview Story Bank`)
};

const fr_story_bank_page_title = /** @type {(inputs: Story_Bank_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview Story Bank`)
};

const es_story_bank_page_title = /** @type {(inputs: Story_Bank_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview Story Bank`)
};

const it_story_bank_page_title = /** @type {(inputs: Story_Bank_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview Story Bank`)
};

const nl_story_bank_page_title = /** @type {(inputs: Story_Bank_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview Story Bank`)
};

const pl_story_bank_page_title = /** @type {(inputs: Story_Bank_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview Story Bank`)
};

const fi_story_bank_page_title = /** @type {(inputs: Story_Bank_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview Story Bank`)
};

const da_story_bank_page_title = /** @type {(inputs: Story_Bank_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview Story Bank`)
};

const sv_story_bank_page_title = /** @type {(inputs: Story_Bank_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview Story Bank`)
};

/**
* | output |
* | --- |
* | "Interview Story Bank" |
*
* @param {Story_Bank_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_page_title = /** @type {((inputs?: Story_Bank_Page_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Page_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_page_title(inputs)
	if (locale === "fr") return fr_story_bank_page_title(inputs)
	if (locale === "es") return es_story_bank_page_title(inputs)
	if (locale === "it") return it_story_bank_page_title(inputs)
	if (locale === "nl") return nl_story_bank_page_title(inputs)
	if (locale === "pl") return pl_story_bank_page_title(inputs)
	if (locale === "fi") return fi_story_bank_page_title(inputs)
	if (locale === "da") return da_story_bank_page_title(inputs)
	if (locale === "sv") return sv_story_bank_page_title(inputs)
	return en_story_bank_page_title(inputs)
});